import AddressModal from "../modal/AddressModal";
import React from "react";
import LocationOffIcon from '@mui/icons-material/LocationOff';
import DefaultAddressCard from "./DefaultAddressCard";

function AddressComponentNew({addresses, setRefreshAddresses, setSelected, isCartItemUpdated, selected, defaultAddress, setDefaultAddress}){
    return (
        <>
        <div className="address-section">
            {addresses?.length > 0 ?  <h2>Address</h2> :  <h3>No Address Added <LocationOffIcon/></h3>}
            {addresses?.length > 0 && 
            defaultAddress && <>
                    <DefaultAddressCard item={defaultAddress} addresses={addresses} setSelected={setSelected} setRefreshAddresses={setRefreshAddresses} setDefaultAddress={setDefaultAddress} selected={selected}/>
                </>
            }
            <div className="common-btn address-btn">
                {addresses?.length === 0 && (
                <button style={{
                    background: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    width: "100%",
                }}
                    data-bs-toggle="modal"
                    data-bs-target="#addressModal">Add New Address <i className="fa-solid fa-plus"></i>
                </button>)}
                <AddressModal setRefreshAddresses={setRefreshAddresses}/>
            </div>
        </div>


        {/* <div className="cart-address-box card-box">
                                <div className="cart-heading"><h3 className="h3 heading heading-light">Delivery Address</h3> <div className="toggleBtnBox" onClick={toggleAddressForm}><span>{showAddAddressForm ? 'Back to Addresses' : 'Add Address'}</span> <FaPlus/></div></div>
                                <div className={`addAddressFormBox ${showAddAddressForm ? 'slide-down' : 'slide-up'}`} sx={{display:'none'}}>
                                    <form action="">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-grp">
                                                    <label htmlFor="">Name : </label>
                                                    <input type="text" className="form-control" placeholder="John Doe" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-grp">
                                                    <label htmlFor="">Email : </label>
                                                    <input type="text" className="form-control" placeholder="johndoe123@gmail.com" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-grp">
                                                    <label htmlFor="">Country Code : </label>
                                                    <select type="text" className="form-control">
                                                        <option value="">+91 India</option>
                                                        <option value="">+91 India</option>
                                                        <option value="">+91 India</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-grp">
                                                    <label htmlFor="">Mobile no. : </label>
                                                    <input type="text" className="form-control" placeholder="9876543210" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-grp">
                                                    <label htmlFor="">Pincode : </label>
                                                    <input type="text" className="form-control" placeholder="000-000" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-grp">
                                                    <label htmlFor="">District : </label>
                                                    <input type="text" className="form-control" placeholder="New Delhi" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-grp">
                                                    <label htmlFor="">Address : </label>
                                                    <input type="text" className="form-control" placeholder="Address line 1" />
                                                    <input type="text" className="form-control" placeholder="Address line 2 (Optional)" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-grp">
                                                    <label htmlFor="">State : </label>
                                                    <input type="text" className="form-control" placeholder="Delhi" />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-grp">
                                                    <label htmlFor="">Country : </label>
                                                    <input type="text" className="form-control" placeholder="India" />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-grp checkBox inner-flex">
                                                    <div className="iconBox"><FaCheckSquare /></div>
                                                    <span>Make this default address</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="btnBox">
                                                    <Button className="btn button btn-2 theme-btn-2">Save Address</Button>
                                                    <Button className="btn button theme-btn">Cancel</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className={`address-list-wrapper  ${showAddAddressForm ? 'slide-up' : 'slide-down'}`}>
                                    {addresses?.length > 0 ?  <h2>Address</h2> :  <h3>No Address Added <LocationOffIcon/></h3>}
                                    <ul className="list">
                                        {addresses?.length > 0 && 
            defaultAddress && <>
                    <DefaultAddressCard item={defaultAddress} addresses={addresses} setSelected={setSelected} setRefreshAddresses={setRefreshAddresses} setDefaultAddress={setDefaultAddress} selected={selected}/>
                </>
            }
                                        <li className="radio-icon-box selected-item">
                                            <div className="icon-box"><FaCircle/></div>
                                            <div className="address-list-box">
                                                <h6 className="h6 name">Aditya Paul</h6>
                                                <p>Faux address 123, faux lane, faux pin-110006 <br />
                                                DELHI, India-110006 <br />
                                                <b>Mobile:</b> 9912345678 <br />
                                                <b>Email:</b> jhondoe23@gmail.com</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
        </>
    )
}
export default AddressComponentNew